// import utils
import dayjs from 'dayjs';

export const getToday = dayjs().toDate();
export const getLastMonth = dayjs().subtract(1, 'month').toDate();
export const getNextMonth = dayjs().add(1, 'month').toDate();
export const getLastWeek = dayjs().subtract(1, 'week').toDate();
export const getNextWeek = dayjs().add(1, 'week').toDate();
export const getStartOfYear = (date: Date) =>
  dayjs(date).startOf('year').toDate();
export const getEndOfMonth = (date: Date) =>
  dayjs(date).endOf('month').toDate();
export const getStartOfMonth = (date: Date) =>
  dayjs(date).startOf('month').toDate();
export const getEndOfWeek = (date: Date) => dayjs(date).endOf('week').toDate();
export const getStartOfWeek = (date: Date) =>
  dayjs(date).startOf('week').toDate();
